let lenis = null;

export const setLenis = (l) => {
  lenis = l;
};

export const getLenis = () => lenis;

export const scrollToId = (id) => {
  if (lenis) {
    lenis.scrollTo(id, { duration: 1.6, easing: (t) => 1 - Math.pow(1 - t, 4) });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};
